import { headers } from "./config";
import api from "./sessionExpiryAxios";
import { SERVICE_HOST } from "../BaseUrl/serviceHost";

export const SUBSCRIPTION_BASE_PATH = SERVICE_HOST;
export const STRIPE_API_PATH = `${SUBSCRIPTION_BASE_PATH}/api/v1/stripe`;

/**
 * Create a Stripe Checkout session for the current clinic, or detect an existing subscription.
 * @returns {Promise<Object>} `{ url }` to redirect to Stripe, or `{ alreadySubscribed, redirect }` if the clinic is already subscribed — unwrapped from the standard envelope.
 */
export const createCheckoutSession = async () => {
    const updatedHeaders = { ...headers };

    try {
        const response = await api.post(`${STRIPE_API_PATH}/create-checkout-session`, undefined, { headers: updatedHeaders });
        if (response.status === 200) {
            return response.data.data;
        }
        throw response;
    } catch (error) {
        console.error("Error creating checkout session:", error);
        throw error;
    }
};

/**
 * Create a Stripe Customer Portal session for the current clinic (update card, cancel, view invoices).
 * @returns {Promise<{ url: string }>} `{ url }` — this endpoint's response is never enveloped, so no unwrapping is needed here (unlike its two siblings above).
 */
export const createPortalSession = async () => {
    const updatedHeaders = { ...headers };

    try {
        const response = await api.post(`${STRIPE_API_PATH}/create-portal-session`, undefined, { headers: updatedHeaders });
        if (response.status === 200) {
            return response.data;
        }
        throw response;
    } catch (error) {
        console.error("Error creating billing portal session:", error);
        throw error;
    }
};
